import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";
import LaboratoryDetailsForm from "../../../components/forms/setup/laboratories/LaboratoryDetailsForm";

export function LaboratoriesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [laboratories, setLaboratories] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getLaboratories = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `laboratories?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setLaboratories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createLaboratory = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("laboratories/create", payload);

    if (callResult.success) {
      showSuccess("Laboratory added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getLaboratories("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddLaboratorySlideOver = (isEdit, item, index) => {
    setSlideOver({
      childComponent: (
        <LaboratoryDetailsForm
          item={item}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateLaboratory(payload, index)
              : createLaboratory(payload)
          }
          title={isEdit ? `Update ${item.name}` : "Add new class"}
        />
      ),
      open: true,
    });
  };

  const updateLaboratory = async function (values, index) {
    let callResult = await makePostApiCall(
      `laboratories/${values.id}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess("Laboratory updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      // const currentItems = [...laboratories.data];
      // var payload = {
      //   index: index,
      //   item: callResult.data.item,
      // };
      // const newItems = updateObjectInArray(currentItems, payload);
      // setLaboratories({ ...laboratories, data: newItems });
      setTimeout(function () {
        getLaboratories("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const deleteLaboratory = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteLaboratory/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = laboratories.data.filter((item) => item.id !== id);
      setLaboratories({ ...laboratories, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteLaboratory = function (item, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLaboratory(item.id, index)}
          message={`Are you sure you want to delete  ${item.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    getLaboratories,
    loading,
    laboratories,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteLaboratory,
    openAddLaboratorySlideOver,
  };
}
